import { useState, useEffect } from 'react';

/**
 * Returns the current timestamp (ms since epoch), updated on a fixed interval.
 *
 * Using Date.now() directly in render bodies fails the no-useless-assignment /
 * Date.now()-purity lint rules because the value is captured at render time and
 * never updated reactively. This hook drives re-renders via state so callers
 * always compare against a stable, effect-driven clock value.
 *
 * @param intervalMs - How often to refresh the clock (default: 60 000 ms / 1 min).
 *                     Subscription/trial checks don't need sub-minute precision.
 */
export function useNowMs(intervalMs = 60_000): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNowMs(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return nowMs;
}
